import Workshop from "../pages/worshop/workshop";

export const allImages = {
    trailer: require("../assets/carousel4.jpg"),
    axle: require("../assets/axle.png"),
    forklift: require("../assets/forklift.png"),
    crane: require("../assets/cranes.png"),
    logo: require("../assets/logo.png"),
    clogo: require("../assets/logos.png"),
    nclogo: require("../assets/logosn.png"),
    vector1: require('../assets/vectors/vector1.png'),
    vector2: require('../assets/vectors/vector2.png'),

    abb: require('../assets/clients/abb.png'),
    enmas: require('../assets/clients/enmas.png'),
    bpl: require('../assets/clients/bpl.png'),
    cairn: require('../assets/clients/cairn.png'),
    bhel: require('../assets/clients/bhel.png'),
    nav: require('../assets/clients/nav.png'),

    hira: require('../assets/testimonials/hira.png'),
    inland: require('../assets/testimonials/inland.png'),
    mantena: require('../assets/testimonials/mantena.png'),
    Rayudu: require('../assets/testimonials/Rayudu.png'),
    sfc: require('../assets/testimonials/sfc.png'),
    Tera: require('../assets/testimonials/Tera.png'),
    xlant: require('../assets/testimonials/xlant.png'),
    srisai: require('../assets/testimonials/srisai.png'),

    faq: require("../assets/faq.png"),
    iso: require("../assets/iso.png"),
    shakehand: require("../assets/shakehand.jpg"),

    aboutus: require("../assets/aboutus/about.png"),
    history: require("../assets/aboutus/history.jpg"),
    target: require("../assets/aboutus/target.png"),
    dotVector: require("../assets/vectors/vector.png"),

    agency: require("../assets/services/agency.png"),
    cargo: require("../assets/services/cargo.png"),
    hiring: require("../assets/services/hiring.png"),
    material: require("../assets/services/material.png"),
    projectcargo: require("../assets/services/projectcargo.png"),

    pick: require("../assets/cranes/pack_carry.png"),
    terrain: require("../assets/cranes/terrain.jfif"),
    truckMounted: require("../assets/cranes/truckMoounted.jpg"),
    chained: require("../assets/cranes/chained.jpeg"),
    mobiletower: require("../assets/cranes/mobiletower.webp"),

    axle2: require("../assets/axles/2axle.jpeg"),
    axle3: require("../assets/axles/3axle.jfif"),
    axle4: require("../assets/axles/4axle.jfif"),
    axle6: require("../assets/axles/6 AXLES.jpeg"),

    high: require("../assets/trailers/high.jfif"),
    semi: require("../assets/trailers/semi.jpeg"),
    low: require("../assets/trailers/low.jpeg"),

    fork: require("../assets/lift/forklift.png"),
    manlift: require("../assets/lift/manlift.jfif"),

    blog: require("../assets/blog.png"),
    announcement: require("../assets/announcment.png"),
    announcementgif: require("../assets/giphy.gif"),
    csr: require("../assets/csri.png"),

    mk80: require("../assets/blogs/MK-80.png"),
    btrailer: require("../assets/blogs/trailer.jpg"),
    final: require("../assets/blogs/final.png"),
    3: require("../assets/blogs/3.png"),
    4: require("../assets/blogs/4.png"),
    6: require("../assets/blogs/6.png"),
    8: require("../assets/blogs/8.png"),
    9: require("../assets/blogs/9.png"),
    10: require("../assets/blogs/10.png"),
    13: require("../assets/blogs/13.png"),
    14: require("../assets/blogs/14.png"),
    15: require("../assets/blogs/15.png"),
    16: require("../assets/blogs/16.png"),
    17: require("../assets/blogs/17.jpg"),
    jetty: require("../assets/blogs/jetty.png"),
    mcdermott: require("../assets/blogs/mcdermott.png"),
    safe: require("../assets/blogs/safe.png"),
    saint: require("../assets/blogs/saint.png"),
    harshini: require("../assets/blogs/harshini.png"),
    mill: require("../assets/blogs/mill.png"),
    vedanta: require("../assets/blogs/vedanta.png"),
    ntpc: require("../assets/blogs/ntpc.png"),


    truckVector: require("../assets/truck.jpeg"),
    forkliftVector: require("../assets/forkliftVector.jpeg"),
    craneVector: require("../assets/induscrane.jpeg"),
    backgroundCard: require('../assets/shipping-port.jpg'),
    bgImage: require('../assets/bg.png'),
    realCrane: require("../assets/realcrane.png"),
    TdImage: require("../assets/3dimage.jpeg"),
    TdImage1: require("../assets/tra.jpeg"),

    mission: require("../assets/mission.png"),
    vision: require("../assets/vision.png"),
    values: require("../assets/values.png"),
    profile: require("../assets/profile.png"),

    //pdf
    brochure: require("../assets/pdf/PBLTransportBrochure.pdf"),
    isocert: require("../assets/pdf/ISO-CERTIFICATE.pdf"),
    agmNotice: require("../assets/pdf/31stAGMNotice.pdf"),
    annualnotice: require("../assets/pdf/AnnualreportFY2025-26.pdf"),
    cs2526: require("../assets/pdf/CSRReportFY25-26.pdf"),
    csrpolicy: require("../assets/pdf/CSR-Policy.pdf"),
    health: require("../assets/pdf/Quality-Occupational-Health-and-Safety-Policy.pdf"),

    energy: require("../assets/services/energy.jpg"),
    factory: require("../assets/services/factory.jpg"),
    international: require("../assets/services/international.jpg"),
    mining: require("../assets/services/mining.jpg"),
    oil: require("../assets/services/oil.jpg"),
    railway: require("../assets/services/railway.jpg"),

    workshop: require("../assets/strengths/workshop.jpg"),
    odc: require("../assets/strengths/odc.jpg"),
    people: require("../assets/strengths/people.jpg"),
    routing: require("../assets/strengths/routing.jpeg"),
    mbs: require("../assets/strengths/mobileserviceunit.jpeg"),
    process: require("../assets/strengths/process.jpg"),
    finance: require("../assets/strengths/finance.jpg"),
    carousel: require("../assets/carousel3.jpg"),
    carousel5: require("../assets/carousel5.jpg"),
    gcsr: {
        school: {
            1: require("../assets/csr/school1 (1).jpg"),
            2: require("../assets/csr/school1 (2).jpg"),
            3: require("../assets/csr/school1 (3).jpg"),
        },
        water: {
            1: require("../assets/csr/waterpipe(1).JPG"),
            2: require("../assets/csr/waterpipe(2).JPG"),
            3: require("../assets/csr/waterpipe(3).JPG"),
        },
        csr2025: {
            water: {
                1: require("../assets/csr/2025/4.jpeg"),
                2: require("../assets/csr/2025/13.jpeg"),
                3: require("../assets/csr/2025/14.jpeg"),
                4: require("../assets/csr/2025/15.jpeg")
            },
            skill: {
                1: require("../assets/csr/2025/11.jpeg"),
                2: require("../assets/csr/2025/9.jpeg"),
                3: require("../assets/csr/2025/7.jpeg"),
            },
            library: {
                1: require("../assets/csr/2025/3.jpeg"),
                2: require("../assets/csr/2025/2.jpeg"),
                3: require("../assets/csr/2025/5.jpeg"),
                4: require("../assets/csr/2025/6.jpeg"),
            }

        }
    },
    Workshop: [
        { image: require("../assets/workshop/1 (1).jpeg") },
        { image: require("../assets/workshop/1 (2).jpeg") },
        { image: require("../assets/workshop/1 (3).jpeg") },
        { image: require("../assets/workshop/1 (4).jpeg") },
        { image: require("../assets/workshop/1 (5).jpeg") },
        { image: require("../assets/workshop/1 (6).jpeg") },
        { image: require("../assets/workshop/1 (7).jpeg") },
        { image: require("../assets/workshop/1 (8).jpeg") },
        { image: require("../assets/workshop/1 (9).jpeg") },
        { image: require("../assets/workshop/1 (10).jpeg") },
        { image: require("../assets/workshop/1 (11).jpeg") },
        { image: require("../assets/workshop/ws (1).jpeg") },
        { image: require("../assets/workshop/ws (2).jpeg") },
        { image: require("../assets/workshop/ws (3).jpeg") },
        { image: require("../assets/workshop/ws (4).jpeg") },
        { image: require("../assets/workshop/ws (5).jpeg") },
        { image: require("../assets/workshop/ws (6).jpeg") },
        { image: require("../assets/workshop/ws (7).jpeg") },
        { image: require("../assets/workshop/ws (8).jpeg") },
        { image: require("../assets/workshop/ws (9).jpeg") },
        { image: require("../assets/workshop/ws (10).jpeg") },
        { image: require("../assets/workshop/ws (11).jpeg") },
        { image: require("../assets/workshop/ws (12).jpeg") },
        { image: require("../assets/workshop/ws (13).jpeg") },
        { image: require("../assets/workshop/ws (14).jpeg") },
        { image: require("../assets/workshop/ws (15).jpeg") },
        { image: require("../assets/workshop/ws (16).jpeg") },
        { image: require("../assets/workshop/ws (17).jpeg") },
        { image: require("../assets/workshop/ws (18).jpeg") },
        { image: require("../assets/workshop/ws (19).jpeg") },
        { image: require("../assets/workshop/ws (20).jpeg") },
    ],
    ourpeople: require("../assets/ourpeople.jpeg")
};